const GOOGLE_ADS_ID = "AW-332808051";
const GOOGLE_ADS_CONVERSION_ID = "AW-332808051/UGUOCKOHpPUbEPP-2J4B";
const GOOGLE_ADS_PAGE_VIEW_CONVERSION_ID = "AW-332808051/VrTkCKTL9ewbEPP-2J4B";
const GOOGLE_TAG_SRC = `https://www.googletagmanager.com/gtag/js?id=${GOOGLE_ADS_ID}`;
const GOOGLE_ADS_CONSENT_KEY = "medicta_google_ads_consent";
const GOOGLE_ADS_CONSENT_GRANTED = {
  ad_storage: "granted",
  analytics_storage: "granted",
  ad_user_data: "granted",
  ad_personalization: "granted",
};
const GOOGLE_ADS_CONSENT_DENIED = {
  ad_storage: "denied",
  analytics_storage: "denied",
  ad_user_data: "denied",
  ad_personalization: "denied",
};

export function getGoogleAdsConsent() {
  if (typeof window === "undefined") {
    return null;
  }

  return window.localStorage.getItem(GOOGLE_ADS_CONSENT_KEY);
}

export function setGoogleAdsConsent(value) {
  if (typeof window === "undefined") {
    return;
  }

  window.localStorage.setItem(GOOGLE_ADS_CONSENT_KEY, value);
  updateGoogleAdsConsent(value);
}

export function canUseGoogleAds() {
  return getGoogleAdsConsent() === "granted";
}

export function updateGoogleAdsConsent(value) {
  if (typeof window === "undefined" || typeof window.gtag !== "function") {
    return false;
  }

  const payload =
    value === "granted"
      ? GOOGLE_ADS_CONSENT_GRANTED
      : GOOGLE_ADS_CONSENT_DENIED;
  window.gtag("consent", "update", payload);
  return true;
}

export function syncGoogleAdsConsent() {
  const consent = getGoogleAdsConsent();
  if (!consent) {
    return false;
  }

  return updateGoogleAdsConsent(consent);
}

export function ensureGoogleTagLoaded() {
  if (typeof window === "undefined") {
    return false;
  }

  if (!canUseGoogleAds()) {
    return false;
  }

  if (!window.dataLayer) {
    window.dataLayer = [];
  }

  if (!window.gtag) {
    window.gtag = function gtag() {
      window.dataLayer.push(arguments);
    };
  }

  if (!document.querySelector(`script[src="${GOOGLE_TAG_SRC}"]`)) {
    const script = document.createElement("script");
    script.async = true;
    script.src = GOOGLE_TAG_SRC;
    document.head.appendChild(script);
  }

  window.gtag("js", new Date());
  window.gtag("config", GOOGLE_ADS_ID);

  return true;
}

export function reportGoogleAdsPageView() {
  if (typeof window === "undefined" || typeof window.gtag !== "function") {
    return false;
  }

  if (!canUseGoogleAds()) {
    return false;
  }

  window.gtag("event", "conversion", {
    send_to: GOOGLE_ADS_PAGE_VIEW_CONVERSION_ID,
  });
  return true;
}

export function reportGoogleAdsConversion({ transactionId = "" } = {}) {
  if (typeof window === "undefined" || typeof window.gtag !== "function") {
    return false;
  }

  if (!canUseGoogleAds()) {
    return false;
  }

  window.gtag("event", "conversion", {
    send_to: GOOGLE_ADS_CONVERSION_ID,
    transaction_id: transactionId,
  });

  return true;
}
